import videojs from 'video.js';

const VJSSeekToLive = videojs.getComponent('SeekToLive');


class SeekToLive extends VJSSeekToLive {
  handleClick() {
    if (this.player().liveTracker.atLiveEdge()) return;

    if (this.player().dash && this.player().dash.mediaPlayer) {
      this.player().dash.mediaPlayer.seek(this.player().dash.mediaPlayer.duration() - 10);

      return;
    }

    this.player().liveTracker.seekToLiveEdge();
  }
}

videojs.registerComponent('SeekToLive', SeekToLive);
export default SeekToLive;
